/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { SeoLocation } from './model/seoLocation';

/**
 * SEO Location View for BrandLocalityService
 */
export const apiSeoLocationCityRetrieve = (
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocation>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${language}/${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'GET',
    signal,
  });
};

export const getApiSeoLocationCityRetrieveQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string,
  extra?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${language}/${city}--${regionSlug}--${seoSlug}/${extra}`,
  ] as const;
};

export const getApiSeoLocationCityRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>, TError, TData>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSeoLocationCityRetrieveQueryKey(
      countryUrlPrefix,
      language,
      city,
      regionSlug,
      seoSlug,
      extra
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>> = ({
    signal,
  }) =>
    apiSeoLocationCityRetrieve(
      countryUrlPrefix,
      language,
      city,
      regionSlug,
      seoSlug,
      extra,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && city && regionSlug && seoSlug && extra),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ApiSeoLocationCityRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>
>;
export type ApiSeoLocationCityRetrieveQueryError = ErrorType<unknown>;

export function useApiSeoLocationCityRetrieve<
  TData = Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof apiSeoLocationCityRetrieve>>, TError, TData>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationCityRetrieveQueryOptions(
    countryUrlPrefix,
    language,
    city,
    regionSlug,
    seoSlug,
    extra,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
